module.exports = __webpack_public_path__ + "static/media/PB_G_12.cd856911.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/progress_bar/green/PB_G_12.png
// module id = 225
// module chunks = 0